import { Injectable } from '@angular/core';
import { TranslationService } from './translate';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  _state: Object = {

    empty: true,

    name: this._translate.instant("Deceased"),
    religion: "Islam", // Islam|Other
    gender: "", // Male|Female|Unknown
    martial_status: "", // Never Married|Other

    asset_value: 100,
    asset_value_movable: 100,

    wife: {
      
      permanent: {
        count: 0,
      },

      temp: {
        count: 0,
        inheritance_condition: []
      },

      divorced: {
        count: 0,
        iddah_rijee_count: 0, // In iddah-e-Talaq or Talaq-e-Rijee
        during_sick: 0, // Within one Lunar year of Talaq (Rijee or Bayin) and husband divorced while he was sick
        wives: [] // {wife_remarried: true|false, divorce_wanted_by_wife: true|false, husband_died_in_same_illness: true|false}
      },

      // level1_wives: [{
      //   name: "",
      //   type: "permanent",// permanent|iddah|sick
      //   eligibility: "",
      //   muslim: "", 
      //   deceased_killer: "", 
      //   free_person: ""
      // }],

      level1_wives: [],

      pregnant: {
        status: "false", //true, false
      }


    },

    husband: {
      name: "Husband",
      eligibility: "",
      //alive: "", //true|false <deprecated>
      relation_type: "", //permanent|Temporary|Divorced
      inheritance_condition: "", //true|false ---> If relation_type is "temporary"
      wife_in_iddah: "", //true|false ---> If relation_type is "divorced"
      divorce_rijee: "", //true|false ---> If wife_in_iddah is "true"
      muslim: "", //true|false
      deceased_killer: "", //true|false
      free_person: "true", //true|false
    },

    father: {
      name: "Father",
      eligibility: "",
      alive: "", //true|false
      muslim: "", //true|false
      legitimate: "", //true|false
      deceased_killer: "", //true|false
      disowned: "true",// true|false
      free_person: "true", //true|false
    },

    mother: {
      name: "Mother",
      eligibility: "",
      alive: "", //true|false
      muslim: "", //true|false
      legitimate: "", //true|false
      deceased_killer: "", //true|false
      free_person: "true", //true|false
    },
    
    survivors: "", // true|false
    unborn_child: "", // true|false
    converted_islam: "", // true|false

    son: {
      count: 0,
      object: new Array(), //{ name: "", muslim: true|false, legitimate: true|false, deceased_killer: true|false, free_person: true|false, disowned: true|false}
    },

    daughter: {
      count: 0,
      object: new Array(), //{ muslim: true|false, legitimate: true|false, deceased_killer: true|false, free_person: true|false, disowned: true|false}
    },

    grand_child: {
      eligibility: "",
      count: 0
    },

    siblings_info: false,

    brother: {
      eligibility: "",
      count: 0
    },

    sister: {
      eligibility: "",
      count: 0
    },

    grandchild: "",

  };


  constructor(public _translate: TranslationService) {
    this.loadFromLocalStorage();
    // console.log("Loaded");
  }

  ngOnInit() {
    this.loadFromLocalStorage();
  }

  // Load value from LocalStorage if values are empty
  loadFromLocalStorage() {
    if( this.get().empty == true ) {
      var last_saved_values = localStorage.getItem('deceased');

      if( last_saved_values ) {
        this._state = JSON.parse(last_saved_values);
      }
    }
  }

  // already return a clone of the current state
  get state() {
    return this._state = this._clone(this._state);
  }
  // never allow mutation
  set state(value) {
    throw new Error('do not mutate the `.state` directly');
  }


  get() {
    // use our state getter for the clone
    // const state = ;
    return this.state;
    //return state.hasOwnProperty(prop) ? state[prop] : state;
  }

  set(value: any) {
    value.empty = false;
    localStorage.setItem('deceased', JSON.stringify(value));
    return this._state = value;
  }

  resetHome() {
    localStorage.removeItem('deceased');
    return this.state;
  }


  private _clone(object: Object) {
    // simple object clone
    return JSON.parse(JSON.stringify( object ));
  }

  reset(event) {
    var sure = confirm(this._translate.instant("Are you sure you want to reset all the entered value?"));

    if( sure ) {
      localStorage.removeItem('deceased');
    
    } else {
      event.preventDefault();  
    }
    
  }

  disableKeyPress(event) {
    var typed_value = parseInt(event.target.value);
    var max_value = parseInt(event.target.max);

    if( typed_value > max_value ) {
      event.target.value = max_value;
      event.preventDefault();
    }
  }
}
